import React from 'react';
import FontAwesome from 'react-fontawesome';
import styles from '../../assets/style/_pallette.scss';

const Failure = ({ text }) => {
    const iconName = 'exclamation-triangle';
    return (
        <div className={`center-aligned full-height flex-centered flex-column defined ${iconName}`}>
            <div className="flex-centered body-header">Whoops!</div>
            <div className="flex-centered body" style={{ color: styles.colorRed }}>
                <span>
                    <FontAwesome className="circle-stroke" name={iconName} size="3x" />
                </span>
            </div>

            <div className="padding-20 flex-centered">{text}</div>
        </div>
    );
};

export default Failure;



// WEBPACK FOOTER //
// ./src/components/Modal/Failure.jsx